<schir-int-client-spinner [stateResource]="verfahren">
	<cdk-virtual-scroll-viewport class="c-list" itemSize="72" [minBufferPx]="1024" [maxBufferPx]="2048">
		<ul class="c-list">
			<li *cdkVirtualFor="let singleVerfahren of getVerfahrenArray()">
				<schir-int-client-verfahren-single [verfahren]="singleVerfahren"/>
			</li>
		</ul>
		@if (hasMore()) {
			<div class="center">
				<button mat-stroked-button matDialogClose data-test-id="mehr-button"
				        class="more-elements-button focus-inwards-dark" matTooltip="Weitere Verfahren anzeigen"
				        aria-label="Weitere Verfahren anzeigen" (click)="loadAllVerfahren()">Mehr
				</button>
			</div>
		}
	</cdk-virtual-scroll-viewport>
</schir-int-client-spinner>
